<div class="p-6 max-w-md">
  <div class="flex items-start gap-3">
    <div
      class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full"
      [class.bg-red-50]="data.danger"
      [class.text-red-600]="data.danger"
      [class.bg-blue-50]="!data.danger"
      [class.text-blue-600]="!data.danger">
      <mat-icon>{{ data.danger ? 'warning_amber' : 'help_outline' }}</mat-icon>
    </div>
    <div class="min-w-0">
      <h2 class="text-lg font-semibold text-slate-900">{{ data.title }}</h2>
      <p class="mt-1 text-sm text-slate-500">{{ data.message }}</p>
    </div>
  </div>

  <div class="mt-6 flex justify-end gap-2">
    <button
      type="button"
      (click)="close(false)"
      class="rounded-lg px-4 py-2 text-sm font-medium text-slate-600 hover:bg-slate-100 transition-colors">
      {{ data.cancelLabel ?? 'Cancel' }}
    </button>
    <button
      type="button"
      (click)="close(true)"
      class="rounded-lg px-4 py-2 text-sm font-semibold text-white transition-colors"
      [class.bg-red-600]="data.danger"
      [class.hover:bg-red-700]="data.danger"
      [class.bg-blue-600]="!data.danger"
      [class.hover:bg-blue-700]="!data.danger">
      {{ data.confirmLabel ?? 'Confirm' }}
    </button>
  </div>
</div>
